"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagTM = function FlagTM(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "57.5",
    y: "1",
    width: "70.62",
    height: "268.36",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95-91.4-87.07-79.63h-28.25L-129.44-91.4v-11.77l14.12-11.77h28.25l14.12,11.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95,7.47-87.07,19.24h-28.25L-129.44,7.47V-4.3l14.12-11.77h28.25L-72.95-4.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95-42-87.07-30.19h-28.25L-129.44-42V-53.73l14.12-11.77h28.25l14.12,11.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95,56.91-87.07,68.68h-28.25l-14.12-11.77V45.14l14.12-11.77h28.25l14.12,11.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-136.5-86.69l14.12,14.12L-136.5-58.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.88-58.44-80-72.57l14.13-14.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-136.5-37.25l14.12,14.12L-136.5-9Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.88-9-80-23.13l14.13-14.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-136.5,12.18l14.12,14.12L-136.5,40.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.88,40.43-80,26.3l14.13-14.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-136.5,61.61l14.12,14.13L-136.5,89.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.88,89.86-80,75.74l14.13-14.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-136.5-122h14.12l-14.12,14.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.88-107.87-80-122h14.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "89.27",
    y: "57.5",
    width: "7.06",
    height: "35.31",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "78.68",
    y: "71.62",
    width: "28.25",
    height: "7.06",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80-59.62l-7.06-5.88v35.31L-80-36.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-122.38-36.08l7.06,5.89V-65.5l-7.06,5.88Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.2-114.94h-14.12l-14.12,11.77v5.89h28.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.2-79.63h14.13L-72.95-91.4v-5.88H-101.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.2-86.69l-14.12-10.55,14.12-10.63,14.13,10.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.2-86.69l14.13-10.55-.06,0H-101.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.2-97.28v-10.59l-14.06,10.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "78.68",
    y: "113.99",
    width: "28.25",
    height: "21.18",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "106.93",
    y: "121.05",
    width: "7.06",
    height: "7.06",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "89.27",
    y: "121.05",
    width: "7.06",
    height: "7.06",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "89.27",
    y: "163.42",
    width: "7.06",
    height: "7.06",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "99.87",
    y: "170.49",
    width: "7.06",
    height: "7.06",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "78.68",
    y: "170.49",
    width: "7.06",
    height: "7.06",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "89.27",
    y: "177.54",
    width: "7.06",
    height: "7.06",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "71.62",
    y: "121.05",
    width: "7.06",
    height: "7.06",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95,106.34l-14.12,11.77h-28.25l-14.12-11.77V94.57l14.12-11.77h28.25l14.12,11.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.2,82.8h-14.12l-14.12,11.77v5.89h28.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.2,118.11h14.13l14.12-11.77v-5.88H-101.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb400"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-87.07,104l-14.13,7.07L-115.32,104v-7l14.12-7.07,14.13,7.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31-83.55a.73.73,0,0,0-.82,1.19,41.05,41.05,0,0,1,13,30A41.66,41.66,0,0,1,1.64-10.59a40.47,40.47,0,0,1-12.16-1.87.73.73,0,0,0-.63,1.3A41.17,41.17,0,0,0,12.46-3.71,42.08,42.08,0,0,0,54.69-45.87,42.06,42.06,0,0,0,31-83.55Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-26.46-56.3l-1.73,4.89,4.06,3.21a.7.7,0,0,1-.44,1.25l-5.19-.13-1.8,4.86a.7.7,0,0,1-1.33-.05l-1.47-5-5.18-.22a.7.7,0,0,1-.37-1.27l4.27-2.94-1.39-5a.7.7,0,0,1,1.1-.74l4.11,3.15,4.32-2.87a.7.7,0,0,1,1,.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5.47-45.7-7.2-40.81l4.06,3.22a.69.69,0,0,1-.45,1.24l-5.18-.13-1.8,4.86a.7.7,0,0,1-1.33-.05l-1.47-5-5.18-.21a.7.7,0,0,1-.37-1.27l4.27-2.94L-16-46a.7.7,0,0,1,1.1-.74l4.11,3.15,4.32-2.87a.7.7,0,0,1,1,.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5.69-67.53l-1.72,4.88,4.06,3.22a.7.7,0,0,1-.45,1.25L-9-58.32l-1.81,4.86a.7.7,0,0,1-1.32,0l-1.48-5-5.17-.22A.7.7,0,0,1-19.13-60l4.27-2.93-1.4-5a.7.7,0,0,1,1.1-.74L-11-65.48l4.32-2.87a.7.7,0,0,1,1,.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5-88.61-6.7-83.72l4.07,3.21a.7.7,0,0,1-.46,1.25l-5.18-.13-1.8,4.86a.7.7,0,0,1-1.33,0l-1.47-5L-18-79.76A.69.69,0,0,1-18.41-81L-14.15-84l-1.39-5a.7.7,0,0,1,1.09-.75l4.12,3.16L-6-89.43a.7.7,0,0,1,1,.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.59-78l-1.72,4.89,4.06,3.21a.7.7,0,0,1-.45,1.25l-5.18-.13-1.81,4.86a.7.7,0,0,1-1.32,0l-1.47-5-5.18-.21a.7.7,0,0,1-.37-1.27l4.27-2.94-1.4-5a.7.7,0,0,1,1.1-.75l4.11,3.16,4.32-2.87a.69.69,0,0,1,1,.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagTM;
exports["default"] = _default;